import * as React from 'react';

function SvgCameraReels(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M6 3a3 3 0 11-6 0 3 3 0 016 0zM1 3a2 2 0 104 0 2 2 0 00-4 0z' />
			<path d='M9 6h.5a2 2 0 011.983 1.738l3.11-1.382A1 1 0 0116 7.269v7.462a1 1 0 01-1.406.913l-3.111-1.382A2 2 0 019.5 16H2a2 2 0 01-2-2V8a2 2 0 012-2h7zm6 8.73V7.27l-3.5 1.555v4.35l3.5 1.556zM1 8v6a1 1 0 001 1h7.5a1 1 0 001-1V8a1 1 0 00-1-1H2a1 1 0 00-1 1z' />
			<path d='M9 6a3 3 0 100-6 3 3 0 000 6zM7 3a2 2 0 114 0 2 2 0 01-4 0z' />
		</svg>
	);
}

export default SvgCameraReels;
